import Tagify from '@yaireo/tagify'
import itemsjs from 'itemsjs';

document.querySelectorAll('.release-list').forEach((releaseList) => {
    // Collect all releases
    const releases = [];
    const teasers = releaseList.querySelectorAll('.release-teaser');

    teasers.forEach((element) => {
        releases.push(JSON.parse(element.dataset.searchObject));
    });

    const itemsJsInstance = itemsjs(releases, {
        aggregations: {
            format: {
                size: 50,
            },
            genres: {
                size: 50,
                conjunction: false,
            },
        },
    });

    // Initialize the filters
    const filters = {};
    let filtered = itemsJsInstance.search({ filters: filters, per_page: 1000 });

    const doFilter = function (e) {
        filtered = itemsJsInstance.search({ filters: filters, per_page: 1000 });

        // Hide filtered teasers
        teasers.forEach((element) => {
            const id = element.dataset.id;
            if (filtered.data.items.some((item) => item.id === id)) {
                element.classList.remove('hidden');
            } else {
                element.classList.add('hidden');
            }
        });

        // Show message if no results
        const noResults = releaseList.querySelector('.release-list__no-results');
        if (filtered.data.items.length === 0) {
            noResults.classList.remove('hidden');
        } else {
            noResults.classList.add('hidden');
        }
    };

    releaseList.querySelectorAll('.list-filters__filter').forEach((filterElement) => {
        const key = filterElement.dataset.key;
        const usedOptions = filtered.data.aggregations[key].buckets.map((item) => item.key);
        const allOptions = JSON.parse(filterElement.dataset.options);

        const options = usedOptions
            .map((option) => allOptions.find((item) => item.value === option))
            .filter((item => item !== undefined));

        if (options.length < 2) {
            filterElement.classList.add('hidden');
            return;
        }

        const inputElement = filterElement.querySelector('input');
        const tagify = new Tagify(inputElement, {
            enforceWhitelist: true,
            tagTextProp: 'label',
            whitelist: options,
            dropdown: {
                enabled: 0, // show suggestions on focus
                searchKeys: ['label', 'searchBy'],
                mapValueTo: 'label',
                maxItems: 15,
            },
        });

        filters[key] = tagify.value.map((item => item.value));

        tagify.on('add', function (e) {
            const value = e.detail.data.value;
            const key = filterElement.dataset.key;
            filters[key].push(value);
            doFilter();

            // Track event
            plausible('Release filter', {
                props: {
                    'Title': document.querySelector('meta[property="og:title"]').content,
                    'Appeared on': window.location.href,
                    'Filter name': key,
                    'Filter value': e.detail.data.hasOwnProperty('label') ? e.detail.data.label : e.detail.data.value,
                }
            });
        });

        tagify.on('remove', function (e) {
            const value = e.detail.data.value;
            const key = filterElement.dataset.key;
            filters[key] = filters[key].filter((item) => item !== value);
            doFilter();
        });
    });

    doFilter();

    // Show the filters
    releaseList.querySelector('.list-filters').classList.remove('hidden');
});
